<template>
  <div class="visit-aaci-summary">
    <div
      v-if="visit.healthReview"
      class="health-review-line small-text mb-1"
      :class="{ 'bg-warning-light px-1': isChanged }"
    >
      <template v-if="isChanged">
        <b>ประวัติสุขภาพ มีการแก้ไข:</b>
        {{ changeLines.join(" · ") }} · {{ reviewerName }}
        {{ time(visit.healthReview.dt) }}
      </template>
      <template v-else>
        <span class="text-success">ประวัติสุขภาพ ✓ ทบทวนแล้ว ไม่มีเปลี่ยนแปลง</span>
        · {{ reviewerName }} {{ time(visit.healthReview.dt) }}
      </template>
    </div>
    <VitalSignsSummary :readings="visit.vitalSigns || []" />
    <div v-if="visit.ackDt" class="description text-muted">
      แพทย์รับทราบก่อนรักษา {{ ackName }} {{ time(visit.ackDt) }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VitalSignsSummary from "@/components/aaci/VitalSignsSummary";
import { describeHealthChanges } from "@/utils/healthReview";

export default {
  name: "VisitAaciSummary",
  components: { VitalSignsSummary },
  props: {
    visit: { type: Object, required: true },
  },
  computed: {
    isChanged() {
      return this.visit.healthReview?.result === "CHANGED";
    },
    changeLines() {
      return describeHealthChanges(this.visit.healthReview?.changes);
    },
    reviewerName() {
      return this.visit.healthReview?.reviewer?.firstNameTh || "";
    },
    ackName() {
      const u = this.visit.ackU;
      return u ? `${u.firstNameTh} ${u.lastNameTh}` : "";
    },
  },
  methods: {
    time(dt) {
      return dt ? moment(dt).format("HH:mm") : "";
    },
  },
};
</script>

<style scoped>
.bg-warning-light {
  background: #fff8db;
}
</style>
